export default {
  props: ['setProducts'],
  data() {
    return {
      hiddenPhotos: [],
    }
  },
  computed: {
    isEditableState() {
      let isEditableState = false;

      if (this.album) {
        isEditableState = this.album.allow_clipping && +this.album.allow_clipping || this.album.allow_filters && +this.album.allow_filters
      }

      return isEditableState;
    },
  },
  watch: {
    completedDrawing(completedDrawing) {
      if (completedDrawing) {
        this.hiddenPhotos.push(completedDrawing.photo);

        setTimeout(() => {
          this.hiddenPhotos = [];
          this.$store.dispatch('SET_COMPLETED_DRAWING', null);
        });
      }
    },
  },
  methods: {
    replacePhoto(product) {
      this.$router.push({hash: '#set-photos'}).catch(() => {});
      this.$store.dispatch('SET_REPLACED_PHOTO_PRODUCT', product);
    },
    showPhotoEditor(photo, sizes) {
      this.$store.dispatch('SET_DRAWING', {photo, sizes});
    },
    deletePhoto(product) {
      const set = this.set;
      const productIndex = this._.findIndex(this.set.products,
          {id: product.id});

      set.products[productIndex].photo = null;

      this.$store.commit('SET_SET', set);
    },
    showProductInformation(productId) {
      let productInformation = null,
          filteredProducts = null,
          sets = [];

      if (this.products && this.products.length > 0) {
        filteredProducts = this.products.filter(item => item.sets);
      }

      if (filteredProducts) {
        sets = this._.first(filteredProducts).sets;
      }

      if (sets.length > 0) {
        let set = this._.find(sets, {id: this.set.id});

        if (set && set.products && set.products.length > 0) {
          productInformation = this._.find(set.products, {id: productId})
        }
      }

      if (productInformation) {
        this.$emit('view-product', productInformation);
      }
    }
  },
};
